(() => {
  const root = document.documentElement;
  root.classList.add('hanfi-render-stability');
  root.classList.add('hanfi-mobile-stability');
  window.__hanfiRenderStability = true;
  window.__hanfiMobileStability = true;

  const visualImageSelector = [
    'main .hanfi-home img',
    'main .hanfi-module img',
    'main .hanfi-product-card__media img',
    'main .hanfi-more-option__media img',
    'main .card-gallery img',
    'main .product-media-gallery img',
    'main media-gallery img',
    'main .product-media img'
  ].join(',');

  const visualElementSelector = [
    'main [data-view-transition-type]',
    'main [data-view-transition-triggered]',
    'main .product-grid__item',
    'main .hanfi-home',
    'main .hanfi-home *',
    'main .hanfi-module',
    'main .hanfi-module *',
    'main .hanfi-related-products',
    'main .hanfi-related-products *',
    'main .hanfi-watch-section',
    'main .hanfi-watch-section *',
    'main .card-gallery',
    'main .card-gallery *',
    'main media-gallery',
    'main media-gallery *'
  ].join(',');

  const revealElement = (element) => {
    if (!(element instanceof HTMLElement)) return;

    element.removeAttribute('data-view-transition-type');
    element.removeAttribute('data-view-transition-triggered');

    if (element.style.contentVisibility === 'hidden') {
      element.style.removeProperty('content-visibility');
    }

    if (element.style.viewTransitionName) {
      element.style.removeProperty('view-transition-name');
    }
  };

  const prepareImage = (img) => {
    if (!(img instanceof HTMLImageElement)) return;

    img.decoding = 'async';
    img.classList.add('hanfi-image-ready');
    img.closest('.hanfi-home__product-media, .hanfi-home__trend-media, .hanfi-home__occasion-media, .hanfi-home__weave-feature, .hanfi-home__weave-tile, .hanfi-home__watch-media, .hanfi-product-card__media, .hanfi-more-option__media, .card-gallery, .product-media-gallery, .product-media-container')?.classList.add('hanfi-media-ready');
  };

  const stabilize = (scope = document) => {
    scope.querySelectorAll?.(visualElementSelector).forEach(revealElement);
    scope.querySelectorAll?.(visualImageSelector).forEach(prepareImage);
  };

  let stabilizeFrame = 0;
  const scheduleStabilize = () => {
    if (stabilizeFrame) return;
    stabilizeFrame = window.requestAnimationFrame(() => {
      stabilizeFrame = 0;
      stabilize(document);
    });
  };

  const init = () => {
    stabilize(document);
    [120, 500, 1200, 2500].forEach((delay) => window.setTimeout(() => stabilize(document), delay));

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.target instanceof HTMLElement) {
          revealElement(mutation.target);
          if (mutation.target instanceof HTMLImageElement) prepareImage(mutation.target);
          continue;
        }

        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          revealElement(node);
          if (node instanceof HTMLImageElement) prepareImage(node);
          stabilize(node);
        });
      }
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style', 'data-view-transition-type', 'data-view-transition-triggered', 'loading'],
      childList: true,
      subtree: true
    });

    window.setTimeout(() => observer.disconnect(), 6000);

    window.addEventListener('pageshow', scheduleStabilize, { passive: true });
    window.addEventListener('resize', scheduleStabilize, { passive: true });
    window.addEventListener('orientationchange', scheduleStabilize, { passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
